import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { Chip } from '@/@bothrs-ui/web/components/chip/Chip'
import { Margin, Padding } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'
import { StSlideGraphic, StSlideWrapper } from './app-update.styled'

export type Props = { title: string; message?: string; graphic: string }

const AppUpdateSlide = ({ title, message, graphic }: Props) => {
  const theme = useTheme()
  return (
    <StSlideWrapper>
      <StSlideGraphic src={graphic} />
      <div>
        <Chip type={'AppUpdate'} glass larger thin>
          {t({
            message: 'Nieuw',
            comment: 'AppUpdate chip',
          })}
        </Chip>
      </div>
      <Margin mb={theme.UI.Spacing.Space8} />
      <H2 color={theme.Colors.Neutrals.Darkest} textAlign='center'>
        {title}
      </H2>
      {message ? (
        <Padding px={theme.UI.Spacing.Space4}>
          <Span type='BodyLargeRegular' textAlign='center' color={theme.Colors.Neutrals.Darkest}>
            {message}
          </Span>
        </Padding>
      ) : null}
    </StSlideWrapper>
  )
}

export { AppUpdateSlide }
